import { render, staticRenderFns } from "./ModalAddShipment.vue?vue&type=template&id=383f9b7f&scoped=true&"
import script from "./ModalAddShipment.vue?vue&type=script&lang=js&"
export * from "./ModalAddShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f9b7f",
  null
  
)

export default component.exports